import React, { useState } from 'react'
import '../choose-purifier-service/choose-for-purifier.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { useSearchParams } from 'react-router-dom'
import SelectInput from '../../common/inputs/SelectInput'
import { billParties, receiptDirections, receiptStatuses, receiptTypes } from '../../../assets/constants/finance'

function FilterReceipt({ setModal }) {
    const [searchParams, setSearchParams] = useSearchParams()

    const [form, setForm] = useState({
        from_date: searchParams.get('from_date') || '',
        end_date: searchParams.get('end_date') || '',
        receipt_no: searchParams.get('receipt_no') || '',
        receipt_type: searchParams.get('receipt_type') || '',
        status: searchParams.get('status') || '',
        party_id: searchParams.get('party_id') || '',
        party_type: searchParams.get('party_type') || '',
        direction: searchParams.get('direction') || ''
    })

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            if (form?.from_date) {
                next.set('from_date', form?.from_date);
            } else {
                next.delete('from_date')
            }

            if (form?.end_date) {
                next.set('end_date', form?.end_date);
            } else {
                next.delete('end_date')
            }

            if (form?.receipt_no) {
                next.set('receipt_no', form?.receipt_no);
            } else {
                next.delete('receipt_no')
            }

            if (form?.receipt_type) {
                next.set('receipt_type', form?.receipt_type);
            } else {
                next.delete('receipt_type')
            }

            if (form?.status) {
                next.set('status', form?.status);
            } else {
                next.delete('status')
            }
            if (form?.direction) {
                next.set('direction', form?.direction);
            } else {
                next.delete('direction')
            }
            if (form?.party_id) {
                next.set('party_id', form?.party_id);
            } else {
                next.delete('party_id')
            }
            if (form?.party_type) {
                next.set('party_type', form?.party_type);
            } else {
                next.delete('party_type')
            }
           
            return next;
        })

        setModal({ status: false })
    }

    return (
        <div className='choose-for-purifier-div'>
            <form action="" onSubmit={handleSubmit}>
                <NormalInput label='From date' type={'date'} name='from_date' value={form?.from_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={form?.end_date} isRequired={false} />
                <NormalInput label='End date' type={'date'} name='end_date' value={form?.end_date || ''} onChangeFun={handleChange}
                    min={'2022-10-11'} max={new Date().toISOString().split('T')[0]} isRequired={false} />
                <NormalInput label='Receipt No' name='receipt_no' value={form?.receipt_no || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Receipt No'} />
                <SelectInput label='Receipt Type' name='receipt_type' onChangeFun={handleChange} isRequired={false}
                    values={receiptTypes.map((v) => ({ option: v, value: v, selected: v === searchParams.get('receipt_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Direction' name='direction' onChangeFun={handleChange} isRequired={false}
                    values={receiptDirections.map((v) => ({ option: v, value: v, selected: v === searchParams.get('direction') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Receipt Status' name='status' onChangeFun={handleChange} isRequired={false}
                    values={receiptStatuses.map((v) => ({ option: v, value: v, selected: v === searchParams.get('status') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <SelectInput label='Party Type' name='party_type' onChangeFun={handleChange} isRequired={false}
                    values={billParties.map((v) => ({ option: v, value: v, selected: v === searchParams.get('party_type') }))}
                    firstOption={{ option: 'Choose...', value: '' }} />
                <NormalInput label='Party Id' name='party_id' value={form?.party_id || ''} onChangeFun={handleChange} isRequired={false}
                    placeholder={'Enter Party Id'} />

                <div className="button-div">
                    <button type='submit'>Filter</button>
                </div>
            </form>
        </div>
    )
}

export default FilterReceipt